import * as React from 'react';
import PageContainer from "@components/PageContainer";
import Block from "@layout/Block";
import Font from "@layout/Font";
import PageTitle from "@layout/PageTitle";
import Pieces from "@layout/pieces/index";
import classnames from 'classnames';
import { FacebookProvider, Like } from 'react-facebook';
import './index.scss';
import { Blog } from '@store/index';
import Disqus from 'disqus-react';

interface OwnProps { 
    blog: Blog;
}

class BlogItemPage extends React.Component<OwnProps> {
    render(): JSX.Element {
        const { blog } = this.props;
        const disqusShortname = 'nick-fit';
        const disqusConfig = {
            url: window.location.href,
            identifier: blog.slug,
            title: blog.name,
        };

        return (
            <PageContainer>
                <Block indent="20">
                    <PageTitle>
                        { blog.name }
                    </PageTitle>
                </Block>
                <Block indent="10">
                    <div className="grid">
                        <div className={classnames('description-main grid-12')}>
                            <div>
                                <Block indent="10">
                                    <Font font="secondary" size={20} lineHeight={14}>
                                        { blog.description }
                                    </Font>
                                </Block>
                                <FacebookProvider appId={process.env.REACT_APP_FACEBOOK_APP_ID}>
                                    <Like href={window.location.href} colorScheme="dark" showFaces={false} share />
                                </FacebookProvider>
                            </div>
                        </div>
                    </div>
                </Block>

                <Pieces pieces={blog.pieces} />

                <Disqus.DiscussionEmbed shortname={disqusShortname} config={disqusConfig} />
	
            </PageContainer>
        );
    }
}

export default BlogItemPage;


// WEBPACK FOOTER //
// ./src/components/Blog/Item/index.tsx